"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultsProvider = void 0;
class DefaultsProvider {
    apply(props) {
        const result = [];
        for (const key in props.featureDefinitions) {
            const definition = props.featureDefinitions[key];
            result.push({ key, value: definition.default, source: 'defaults' });
        }
        return result;
    }
}
exports.DefaultsProvider = DefaultsProvider;
//# sourceMappingURL=defaults-provider.js.map